import { Alert } from '@creditornot/cb-alert';
import { Checkbox } from '@creditornot/cb-checkbox';
import { InputContainer } from '@creditornot/cb-form';
import { cbSemanticCssVars, typographyCss } from '@creditornot/cb-ingredients';
import { Textarea } from '@creditornot/cb-input';
import { Radio, RadioCard } from '@creditornot/cb-radio';
import styled from 'styled-components';

import InputNumber from 'common/components/InputNumber';
import { Typography as T } from 'common/typography';
import MultiImageUploadInput from 'modules/menu/components/ImageUploadInput/MultiImageUploadInput';
import FormValueContainer from 'modules/menu/items/components/Item/ItemDetails/FormValueContainer';

const MAX_TEXTAREA_ROWS = 10;

export const DisplayText = styled(T.Body3).attrs({ dir: 'auto' })``;

export const StyledAlert = styled(Alert).attrs({ size: 'small' })`
  margin: 8px 8px 0;
`;

export const ProductInfoValue = styled.div`
  flex: 1 1 0; /* Ensure long lines don't mess up layout */
  white-space: pre-wrap; /* Product info values can have line breaks, so render them correctly */
`;

export const StyledFormValueContainer = styled(FormValueContainer)`
  & + & {
    margin-block-start: 16px;
  }
`;

export const StyledInputContainer = styled(InputContainer)`
  max-width: 392px;
`;

export const UnitDetailsSelectionWrapper = styled.div`
  display: inline-flex;
  flex-direction: row;
  width: 100%;
  margin-block-end: 8px;
`;

export const StyledRadioCard = styled(RadioCard)`
  & + & {
    margin-inline-start: 8px;
  }
  width: 100%;
  padding: 8px 12px;
`;

export const StyledTextarea = styled(Textarea).attrs({
  autoresizeMaxRows: MAX_TEXTAREA_ROWS,
})``;

export const StyledMultiImageUploadInput = styled(MultiImageUploadInput)`
  max-width: 392px;
`;

export const ColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledCheckbox = styled(Checkbox)`
  & + & {
    margin-block-start: 12px;
  }
`;

export const RadioWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const WeeklyScheduleWrapper = styled.div`
  max-width: 392px;
  border-block-start: 1px solid ${cbSemanticCssVars.borderPrimary};
  padding-block-start: 24px;
  margin-block-start: 24px;
`;

export const StyledRadio = styled(Radio)`
  & + & {
    margin-block-start: 12px;
  }
`;

export const FormRowWrapper = styled.div`
  display: flex;
`;

export const PurchaseQuantityWrapper = styled.label`
  width: 50%;
  & + & {
    margin-inline-start: 8px;
  }
`;

export const PurchaseQuantityLabel = styled.div`
  ${typographyCss.Body3()};
  color: ${cbSemanticCssVars.textSecondary};
  margin-block-end: 8px;
`;

export const PreviewRowContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const InventoryData = styled.div`
  ${typographyCss.Small()};
  margin-block-start: 12px;
`;

export const StyledInputNumber = styled(InputNumber)`
  max-width: 392px;
`;
